<template>
  <base-layout>
    <div style="height:100%">
      <template>
        <div class="tasks_details_top">
          <div class="row m0">
            <div
              class="col-md-12"
              style="margin-top:20px;border-bottom: 1px solid #CEDAE6;padding-bottom:16px;"
            >
              <div class="col-md-6">
                <div class="detail">
                  <h3 style="font-weight: 600;color:#475259">{{TaskDetails.Title}}</h3>
                  <div class="task_date">
                    <img style="width: 16px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_timestamp.svg`" />
                    <span
                      style="padding-left: 5px;font-weight: 600;font-size:12px;margin-right:5px;"
                    >{{TaskDetails.CreatedDate}}</span>
                    <span
                      style="font-weight: 400;font-size:12px;margin-right:5px;"
                    >| Created By: {{CreatedBy}}</span>
                    <span style="font-weight: 400;font-size:12px;margin-right:5px;">| Estimated Duration: {{TaskDetails.EstimatedDuration}}</span>
                    <!-- <span
                      v-if="TaskDetails.Status != 'None'"
                      v-bind:class="TaskDetails.Status == 'Pending' ? 'status':'status1'"
                    >{{TaskDetails.Status}}</span> -->
                  </div>
                </div>
              </div>
              <div class="col-md-3" style="color:#475259;padding-left: 70px;">
                <span v-if="!isTaskEdit" :class="{ 'deleteTask':deleteDisable(TaskDetails) }" @click="editTask(TaskDetails)">
                  <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_edit.svg`" />
                  <span class="design" :class="{ 'deleteTask':deleteDisable(TaskDetails) }">Edit</span>
                </span>
                <span v-else :class="{'active_link': isTaskEdit}">
                  <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_edit-hover.svg`" />
                  <span class="design">Edit</span>
                </span>
                <span
                  :class="{ 'deleteTask':deleteDisable(TaskDetails) }"
                  v-if="!isTaskDelete"
                  @click="confirmDeleteTask(TaskDetails)"
                >
                  <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_delete.svg`" />
                  <span class="design" :class="{ 'deleteTask':deleteDisable(TaskDetails) }">Delete</span>
                </span>
                <span v-else :class="{'active_link':isTaskDelete}">
                  <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_delete-hover.svg`" />
                  <span class="design">Delete</span>
                </span>
              </div>
              <div class="col-md-3" style="text-align: right;">
                <span
                  style="font-weight: 600;color:#475259;padding-right:30px;"
                >{{CurrentTaskNumber}} of {{TotalTasksCount}} {{TaskMessage}}</span>
                <span
                  :class="{'previous' : PreviousTaskId != '', 'not_allowed': PreviousTaskId == '' }"
                  @click="handlePreviousTaskRequest()"
                >
                  <img class="nextImg" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_previous.svg`" />
                </span>
                <span
                  :class="{'next' : NextTaskId != '', 'not_allowed': NextTaskId == '' }"
                  @click="handleNextTaskRequest()"
                >
                  <img class="nextImg" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_next.svg`" />
                </span>
                <span class="cross-mark">
                  <span class="nextImg" @click="onClose" style="font-size: 15px">&#10006;</span>
                </span>
              </div>
            </div>
          </div>
          <div class="row task_details_description">
            <div class="col-md-12">
              <div class="col-md-8 task_details_bottom_left">
                <div class="row">
                  <div class="col-md-12">
                    <ob-collapse :type="10" :expand="true">
                      <h4
                        class="h4_design"
                        style=" font-weight: 600; color:#475259;font-size:13.5px;"
                        slot="collapse-title"
                      >
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_description.svg`" style="padding-right:8px;" />
                        Description
                      </h4>
                      <div slot="collapse-details">
                        <div
                          style="text-align: justify;min-height: 74px;word-break: break-word;white-space: pre-line;"
                        >
                          {{getContent(Description)}}
                          <a
                            v-if="Description.length > 1200"
                            @click="Loadmore = !Loadmore "
                            style="color:#4a90e2 !important;font-weight: 600;"
                          >{{Loadmore ? 'show more' :'...show less'}}</a>
                        </div>
                        <!-- <ob-textarea v-model.trim="Description" @input="showSaveButton()" ></ob-textarea>
                        <ob-button style="margin-bottom: 10px;margin-top: 8px;" :disabled="!saveDescriptionButton" @click="updateDescription()" type="primary" >Save</ob-button>-->
                      </div>
                    </ob-collapse>
                  </div>
                </div>
                <div class="row task_details_comments">
                  <div class="col-md-12 comments">
                    <comments
                      :content="clonedContent"
                      :Comments.sync="CommentList"
                      ref="CommentComponent"
                      :loadComments.sync="loadComments"
                    ></comments>
                  </div>
                </div>
              </div>
              <div class="col-md-4 task_details_bottom_right">
                <div class="row task_details_tools">
                  <div class="col-md-12">
                    <tools-used
                      ref="toolComponent"
                      :tools.sync="Toolslist"
                      :content.sync="clonedContent"
                    ></tools-used>
                  </div>
                </div>
                <div class="row task_details_attachments">
                  <div class="col-md-12">
                    <attachments
                      ref="attachmentsComponent"
                      :attachments="AttachmentList"
                      :content.sync="clonedContent"
                    ></attachments>
                  </div>
                </div>
                <div class="row" v-if="$route.query.from != null && $route.query.from != '' && $route.query.from != 'ess-dashboard'">
                  <div class="col-md-12">
                    <linked-emps ref="linkedEmps" :LinkedEmployeesList.sync="LinkedEmployeesList" :TaskId="CurrentTaskId"></linked-emps>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <add-task
          @close="close"
          :openModal.sync="openAddTaskPopup"
          :IsEdit="true"
          :PreviousData="clonedContent"
        ></add-task>
      </template>
       <template>
        <ob-modal2 :show.sync="openAddUnTrustedSitesPop" :type="1">
        <div class="" style="padding:30px 15px;text-align:center">
          <img style="width:45px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info_red_icon.svg`" />
          <p class="warning-content">OnBlick Trusted Sites</p>
          <h4 style="LINE-HEIGHT: 20px;display: inline;">This domain is not included in our trusted sites. <br/>
                However, you can add this to our trusted domains by clicking on 'Add'.
          </h4>
          <div style="padding-top: 5%">
            <span style="font-weight: bold;padding-top:10px;text-align:center;padding-bottom: 10px;">{{this.UnTrustedLink}}</span> 
            </div>    
        </div>
        <div class="modal-soc--footer" style="padding: 0px 20px 20px 20px;text-align:center;">
          <ob-button type="secondary"  @click="cancelAddPopup">Cancel</ob-button>
          <ob-button @click="AddTrustedSitesLinkPopup">Add</ob-button>
        </div>
      </ob-modal2>
       <ob-modal2 :show.sync="openDeleteTaskPopup" :type="1" width="540px">
        <div class="" style="padding:30px 30px;text-align:center">
          <img style="width:100px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/reminder_note.svg`" />
          <p class="warning-content" style="color: #e46481;font-size:18px;">Delete Task</p>
          <h4 style="display: inline;line-height: 20px;">By deleting task will erase all information regarding this task.<br> Are you sure want to delete?
          </h4>
          <div style="padding-top:3%" v-if="linkedEmpLength > 1">
            <ob-checkbox name="check-box" v-model="IsDeleteAll"><span class="checkbox-label" style="font-size:13px;color: #2c2c3de8;font-weight: 600;">Delete this task for other linked ({{linkedEmpLength-1}}) employees</span></ob-checkbox>
          </div>   
        </div>
        <div class="modal-soc--footer" style="padding: 0px 20px 20px 20px;text-align:center;">
          <ob-button type="secondary"  @click="openDeleteTaskPopup = false, IsDeleteAll = false">Cancel</ob-button>
          <ob-button @click="deleteTask">Delete</ob-button>
        </div>
      </ob-modal2>
    </template>
    </div>
  </base-layout>
</template>
<script>
import LinkedEmps from './LinkedEmployees.vue'
import Attachments from "./Attachments.vue";
import Comments from "./Comments.vue";
import ToolsUsed from "./ToolsUsed.vue";
import AddTask from "./AddTask.vue";
import c from "@/components/Core/constants.js";
export default {
  data() {
    return {
      IsDeleteAll:false,
      openDeleteTaskPopup:false,
      view: "",
      saveDescriptionButton: false,
      openAddTaskPopup: false,
      openAddUnTrustedSitesPop:false,
      show: false,
      loadComments: false,
      Description: "",
      isEdit: false,
      isTaskEdit: false,
      isTaskDelete: false,
      isDelete: false,
      TaskDetails: [],
      Loadmore: true,
      UnTrustedLink:'',
      Attachmentlinks:'',
      
    };
  },
  components: {
    attachments: Attachments,
    comments: Comments,
    "tools-used": ToolsUsed,
    "add-task": AddTask,
    "linked-emps" : LinkedEmps
  },
  watch: {
    openModal(val) {
      this.show = val;
      if (val) {
        // On Modal Open
        this.fetchTaskDetails();
      }
    },
    show(val) {
      this.$emit("update:openModal", val);
    }
  },
  created() {
    this.view = this.$route.query.isListview;
    let interval = setInterval(() => {
      clearInterval(interval);
      this.fetchTaskDetails();
    }, 500);
  },
  computed: {
    LinkedEmployeesList(){
      return this.TaskDetails.LinkedEmployeesList
    },
    CreatedBy() {
      if (this.TaskDetails.CreatedBy) {
        return (
          this.TaskDetails.CreatedBy.FirstName +
          " " +
          this.TaskDetails.CreatedBy.LastName
        );
      }
    },
    CommentList() {
      var commentList = [];
      var localCommentObj = this.clonedContent.Comments;
      if (localCommentObj) {
        for (var i = 0; i < localCommentObj.length; i++) {
          var comment = {
            Id: localCommentObj[i].Id,
            isEdit: false,
            CreatedBy:
              localCommentObj[i].CreatedBy.FirstName +
              " " +
              localCommentObj[i].CreatedBy.LastName,
            CreatedDate: localCommentObj[i].CreatedDate,
            Content: localCommentObj[i].Content,
            commentByMail: localCommentObj[i].CreatedBy.Email,
            ProfilePicLink:
              localCommentObj[i].CreatedBy.ProfilePicLink != ""
                ? localCommentObj[i].CreatedBy.ProfilePicLink
                : `${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/noimage.svg`
          };
          commentList.push(comment);
        }
      }

      return commentList;
    },
    Toolslist() {
      return this.TaskDetails.ToolsUsed;
    },
    AttachmentList() {
      return this.TaskDetails.Attachments;
    },
    clonedContent: {
      get() {
        return this.TaskDetails;
      },
      set(val) {
        this.$emit("update:content", val);
      }
    },
    CurrentTaskNumber() {
      return this.TaskDetails.CurrentTaskNumber;
    },
    TotalTasksCount() {
      return this.TaskDetails.TotalTasks;
    },
    NextTaskId() {
      return this.TaskDetails.NextTaskIdList;
    },
    PreviousTaskId() {
      return this.TaskDetails.PreviousTaskIdList;
    },
    TaskMessage() {
      let message = "Task";
      if (this.TotalTasksCount > 1) message = "Tasks";
      return message;
    },
    CurrentTaskId() {
      return this.TaskDetails.TaskId;
    },
    linkedEmpLength(){
      return this.TaskDetails.LinkedEmployeesList && this.TaskDetails.LinkedEmployeesList.length
    }
  },
  methods: {
    getContent(Description) {
      if (this.Loadmore && Description.length > 1200) {
        return Description.substring(0, 1200) + "...";
      } else return Description;
    },
    showSaveButton() {
      this.saveDescriptionButton = true;
    },
    handlePreviousTaskRequest() {
      if (this.PreviousTaskId != "") {
        let from = this.$route.query.from;
        let empId = this.$route.query.EmployeeId;
        let url = "";
        if (from == "ReportingEmployee") {
          this.$router.push({
            name: this.$route.name,
           // params: { id: this.PreviousTaskId },
            query: { id: this.PreviousTaskId, EmployeeId: empId, from: from }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: { id: this.PreviousTaskId, EmployeeId: empId, from: from }
          });
        }
        this.fetchTaskDetails("fetchDetails");
      }
    },
    handleNextTaskRequest() {
      if (this.NextTaskId != "") {
        let from = this.$route.query.from;
        let empId = this.$route.query.EmployeeId;
        let url = "";
        if (from == "ReportingEmployee") {
          this.$router.push({
            name: this.$route.name,
            //params: { id: this.NextTaskId },
            query: {id: this.NextTaskId, EmployeeId: empId, from: from }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: { id: this.NextTaskId, EmployeeId: empId, from: from }
          });
        }
        this.fetchTaskDetails("fetchDetails");
      }
    },
    commanServiceForUpdate(Obj, link) {
      this.UnTrustedLink = link
      this.Attachmentlinks = Obj
      this.$loading({ loadingText: "Please wait..." });
      var Id = this.$route.params.id;
      ajax.put(`/Task/${Id}/AddResource`, Obj, res => {
        if (res.data.State == true) {
          this.fetchTaskDetails("fetchDetails");
          this.handlingLocalObject(Obj);
        } else {
            if(res.data.Message != "This Link has been already Attached")
            {
              this.openAddUnTrustedSitesPop = true
            }
          else{
              this.$message({
              type: 'error',
              message: res.data.Message
            });
          }
         this.$loading({}).close();
        }
      });
    },
    fetchTaskDetails(fetchDetails) {
      var taskId = '';
      if(this.$route.params.id != undefined && this.$route.params.id != null){
        taskId = this.$route.params.id
      }
      else{
       taskId = this.$route.query.id;
      }
      var taskEmpId = ''
      if(this.$route.query.empId != undefined && this.$route.query.empId != null){
        taskEmpId =  this.$route.query.empId
      }
      else{
        taskEmpId =  this.$route.query.EmployeeId
      }
      this.$loading({ loadingText: "Please wait..." });
      ajax.get(`/Task/${taskId}/${taskEmpId}`, {}, res => {
        if (res.data.State == true) {
          this.Description = "";
          this.TaskDetails = [];
          this.TaskDetails = res.data.TaskMetaData;
          this.Description = res.data.TaskMetaData.Description;
          this.isLoading = false;
          this.$loading({}).close();
        } else {
          this.$message({
            type: "error",
            message: res.data.Message
          });
          if(this.$route.query.from == "ReportingEmployee"){
             this.$router.push({ name: "employee-tasks-trainee" ,query: { EmployeeId: taskEmpId ,from: "ReportingEmployee", isListview: "true" }});
          }
          else{
            this.$router.push({ name: "employee-tasks" });
          }
          this.$loading({}).close();
        }
      });
    },
     cancelAddPopup() {
      this.openAddUnTrustedSitesPop = false;
    },
    AddTrustedSitesLinkPopup() {
      var url = this.UnTrustedLink;
      var obj = this.Attachmentlinks;
      ajax.put(`Task/TrustedSites?Id=${this.$route.params.id}&url=${url}`, obj, res => {
       
      if (res.data.State == true) {
         this.openAddUnTrustedSitesPop = false
         this.fetchTaskDetails('fetchDetails')
          this.$message({
            type: "success",
            message: "Attachment/Link added successfully"
          });
        }
      else{
            this.$message({
            type: 'error',
             message: res.data.Message
            
           });
          this.$loading({}).close();
        }
      });
    
    },

    deleteResource(Obj) {
      this.$loading({ loadingText: "Please wait..." });
      ajax.put(`Task/DeleteResource`, Obj, res => {
        if (res.data.State == true) {
          this.fetchTaskDetails("fetchDetails");
          this.handlingLocalObjectForDelete(Obj);
        } else {
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    },
    handlingLocalObjectForDelete(Obj) {
      if (Obj.Type == 1) {
        this.$message({
          type: "success",
          message: ResourceCore.Messages["Tools_Deleted"]
        });
      } else if (Obj.Type == 2) {
        this.$message({
          type: "success",
          message: ResourceCore.Messages["Attachments_Deleted"]
        });
      } else if (Obj.Type == 3) {
        this.$message({
          type: "success",
          message: ResourceCore.Messages["Comment_Deleted"]
        });
      }
    },
    handlingLocalObject(Obj) {
      if (Obj.Type == 1) {
        this.$message({
          type: "success",
          message: ResourceCore.Messages["Tools_Added"]
        });
      } else if (Obj.Type == 2) {
        this.$message({
          type: "success",
          message: ResourceCore.Messages["Attachments_Added"]
        });
      } else if (Obj.Type == 3) {
        this.$message({
          type: "success",
          message: ResourceCore.Messages["Comment_Added"]
        });
      } else if (Obj.Type == 4) {
        this.$message({
          type: "success",
          message: ResourceCore.Messages["Previous_Comment_Added"]
        });
      } else {
        this.$message({
          type: "success",
          message: ResourceCore.Messages["Task_Update"]
        });
      }
    },
    editTask(TaskDetails) {
      if (!this.deleteDisable(TaskDetails)) {
        this.isTaskEdit = true;
        this.isTaskDelete = false;
        this.openAddTaskPopup = true;
      }
    },
    deleteDisable(TaskDetails) {
      let from = this.$route.query.from;
      if (from == "ReportingEmployee") {
        return false;
      } else {
        if (
          TaskDetails &&
          TaskDetails.TaskCreatedBy &&
          TaskDetails.TaskCreatedBy.Email == this.loggedInUserObj.email
        ) {
          return false;
        } else return true;
      }
    },
    confirmDeleteTask(TaskDetails){
      let from = this.$route.query.from
      if (!this.deleteDisable(TaskDetails)) {
        if(from != null && from != '' && from != 'ess-dashboard'){
          this.openDeleteTaskPopup = true
        }
        else{
          this.$alert2("Are you sure you want to delete ?", "Alert", {
            type: "confirm",
            yesButtonText: "Yes",
            noButtonText: "No",
            callback: (action) => {
              if(action === true) {
                this.deleteTask();
              }
            }
          });
        }
      }
    },
    deleteTask() {
      var empId = this.$route.query.EmployeeId
      var obj = {}
      obj.EmployeeId = empId
      obj.IsDeleteAll = this.IsDeleteAll
      this.isTaskDelete = true;
      this.isTaskEdit = false;
      this.$loading({ loadingText: "Loading..." });
      ajax.put(`/Task/${this.CurrentTaskId}/Delete`, obj, response => {
        this.IsDeleteAll = false
        this.openDeleteTaskPopup = false
        if (response.data.State == true) {
          this.redirectToEmployeeTasks();
        }
        this.$loading({}).close();
        this.isTaskDelete = false;
      });
    },
    onClose() {
      this.redirectToEmployeeTasks();
    },
    redirectToEmployeeTasks() {
      let from = this.$route.query.from;
      let empId = this.$route.query.EmployeeId;
      let url = "";
      if (from == "ReportingEmployee") {
        this.$router.push({
          name: "employee-tasks-trainee",
          query: {
            EmployeeId: empId,
            from: "ReportingEmployee",
            isListview: this.view
          }
        });
      } else if (from == "ess-dashboard") {
        // window.createConnection();
        this.$router.push({ name: "ess-dashboard" });
      } else {
        this.$router.push({
          name: "employee-tasks",
          query: { isListview: this.view }
        });
      }
    },
    close() {
      this.isTaskEdit = false;
      this.isTaskDelete = false;
      this.fetchTaskDetails("fetchDetails");
    },
    updateDescription() {
      this.$loading({ loadingText: "Please wait..." });
      this.saveDescriptionButton = false;
      var TaskId = this.TaskDetails.TaskId;
      var Obj = {
        Title: "",
        Description: this.Description,
        EmployeeId: "",
        CreatedDate: "",
        CreatedBy: ""
      };
      ajax.put(`/Task/${TaskId}/Update`, Obj, res => {
        if (res.data.State == true) {
          this.fetchTaskDetails("fetchDetails");
          this.$message({
            type: "success",
            message: "Description updated successfully"
          });
          this.$loading({}).close();
        } else if (res.data.State == false) {
          this.$loading({}).close();
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tasks_details_top {
  height: 100%;
  width: 100%;
  background-color: white;
  overflow-x: hidden;
  overflow-y: auto;
}
.design {
  font-size: 14px;
  font-weight: 600;
  padding: 10px;
  &:hover {
    cursor: pointer;
  }
}
.h4_design {
  font-weight: 600;
  color: #475259;
  font-size: 13.5px;
}
.task_date {
  color: #717170;
}
.active_link {
  color: #337ab7 !important;
  text-decoration: underline;
}
.cross-mark,
.next,
.previous {
  &:hover {
    cursor: pointer;
  }
}
.not_allowed {
  &:hover {
    cursor: not-allowed;
  }
}
.status {
  color: #f4a624;
  margin-left: 0px;
  border: 1px solid #f4a624 !important;
  background: #fef6e9 !important;
  padding: 0px 12px;
  display: inline-block;
  border-radius: 30px;
  font-weight: 550;
}
.status1 {
  color: #82ccb0;
  margin-left: 0px;
  border: 1px solid #82ccb0 !important;
  background: #e8f4f1 !important;
  padding: 0px 12px;
  display: inline-block;
  border-radius: 30px;
  font-weight: 550;
}
.previous {
  border-radius: 5px;
  padding: 5px 2px 4px 3px;
}
.next {
  border-radius: 5px;
  padding: 5px 2px 4px 3px;
}
.previous:hover,
.next:hover,
.cross-mark:hover {
  background-color: #f6f7f8;
}
.nextImg {
  padding: 2px 16px 2px 5px;
  margin-right: -9px;
  margin-top: -5px;
}
.cross-mark {
  border-radius: 5px;
  padding: 5px 1px 4px 2px;
}
.deleteTask {
  cursor: not-allowed !important;
  color: #00000057 !important;
}
.warning-content{
    font-weight: 600;
    font-size: 16px;
    padding-top: 10px;
    padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/TaskDetails.vue